import VerifyEmail from "views/VerifyEmailView";

export default function Page() {
  return (
    <>
      <VerifyEmail />
    </>
  );
}
